module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<label class="block">\n <input type="checkbox" class="toggle-subwidget-region">\n <span class="custom-checkbox"></span>\n  ' +
__e( type ) +
'\n  </label>\n<div class="toggle-subwidget-region"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ShowSubWidgetView.tpl
// module id = 2090
// module chunks = 0